import React, { useMemo } from 'react'
import { Route } from 'react-router-dom'
import SolarPowerData from './SolarPowerData'
import { hasAccesPermits } from 'core'
import * as ScreenPermissions from 'core/EventActions'
import SolarPlant from './admin/SolarPlant'
import SolarEntity from './admin/SolarEntity'
import SolarDaysCreation from './admin/SolarDaysCreation'
import SolarInverterGroup from './admin/SolarInverterGroup'
import SolarInverterManufacturer from './admin/SolarInverterManufacture'
import SolarScadaManfacturer from './admin/SoalrScadaManf'
import SolarStorageGroup from './admin/SolarStorageGroup'
import SolarStorageGroupFormation from './admin/SolarStorageInverterFormation'
import SolarStorageInverterManufacturer from './admin/SolarStorageInverterManufacturer'
import SolarStorageManufacturer from './admin/SolarStorageManufacturer'
import SolarCausecode from './admin/SolarCausecode'
import SolarErrors from './admin/SolarErrors'
import SolarLockcheck from './admin/SolarLockcheck'
import SolarUserPlant from './admin/SolarUserPlant'
import SolarLevel2Validation from './SolarLevel2Validation'
import SolarInverterFormation from './admin/SolarInverterFormation'
import SolarInverterPerformacePowerData from './SolarInverterPerformacePowerData'
import SolarGenerationData from './SolarGenerationData'
import SolarFileCreation from './solarfilecreation/SolarFileCreation'
import SolarCSVImport from './SolarCSVImport'
import SolarNercFileImport from './solarNercFileImport/SolarNercFileImport'
import SolarReport from './SolarReport'
import SolarMissingData from './SolarMissingData'
import SolarPiDataImport from './SolarPiDataImport'
import SolarLSBPEvent from './lsbp/Events'
import SolarLSBPMeasurment from './lsbp/Measurment'
import SolarStoragePowerData from './SolarStoragePowerData'
import SolarPiRow10MinData from '../pirowdata/solar/SolarPiRow10MinData'
import SolarPiRowHourlyData from '../pirowdata/solar/SolarPiRowHourlyData'
import SolarPiRowDailyData from '../pirowdata/solar/SolarPiRowDailyData'
import SolarPlantExtraInfo from './admin/SolarPlantExtraInfo'

const SolarStorageStandalonePowerData = props => (
  <SolarStoragePowerData {...props} isStandalone />
)

export { SolarPowerData, SolarInverterPerformacePowerData, SolarGenerationData }

const SolarContainer = ({ actionPermits }) => {
  // const windAdminScreenAccess = useMemo(
  //   _ =>
  //     hasAccesPermits({
  //       authGodMode: envConfig.authGodMode,
  //       actionPermits,
  //       eventActions: [ScreenPermissions.WIND_ADMIN_SCRREEN_PERMISSIONS],
  //       matchAny: true,
  //     }),
  //   [actionPermits, envConfig.authGodMode]
  // )
  const hasSolarPowerData = useMemo(
    _ =>
      hasAccesPermits({
        actionPermits,
        eventActions: [
          ScreenPermissions.SOLAR_POWER_DATA,
          ScreenPermissions.SOLAR_ADMIN_POWER_DATA,
        ],
        matchAny: true,
      }),
    [actionPermits]
  )

  const solarAdminScreenAccess = useMemo(
    _ =>
      hasAccesPermits({
        actionPermits,
        eventActions: [ScreenPermissions.SOLAR_ADMIN_SCRREEN_PERMISSIONS],
        matchAny: true,
      }),
    [actionPermits]
  )

  const solarFileCreation = useMemo(
    _ =>
      hasAccesPermits({
        actionPermits,
        eventActions: [ScreenPermissions.SOLAR_FILE_CREATION],
        matchAny: true,
      }),
    [actionPermits]
  )

  const solarPiImportIntervals = useMemo(
    _ =>
      hasAccesPermits({
        actionPermits,
        eventActions: [ScreenPermissions.SOLAR_PI_IMPORT_INTERVALS],
        matchAny: true,
      }),
    [actionPermits]
  )

  const solarFileImport = useMemo(
    _ =>
      hasAccesPermits({
        actionPermits,
        eventActions: [ScreenPermissions.SOLAR_FILE_IMPORT],
        matchAny: true,
      }),
    [actionPermits]
  )

  const solarFileImportCSV = useMemo(
    _ =>
      hasAccesPermits({
        actionPermits,
        eventActions: [ScreenPermissions.SOLAR_FILE_IMPORT_CSV],
        matchAny: true,
      }),
    [actionPermits]
  )

  const solarReportAccess = useMemo(
    _ =>
      hasAccesPermits({
        actionPermits,
        eventActions: [ScreenPermissions.SOLAR_REPORT],
        matchAny: true,
      }),
    [actionPermits]
  )

  const solarLSBP = useMemo(
    _ =>
      hasAccesPermits({
        actionPermits,
        eventActions: [ScreenPermissions.LSBP_SF_EVENT_MEASURMENT],
        matchAny: true,
      }),
    [actionPermits]
  )

  const showSolarStorageStandaloneData = useMemo(
    _ =>
      hasAccesPermits({
        actionPermits,
        eventActions: [
          ScreenPermissions.SHOW_SOLAR_STORAGE_STANDALONE_DATA,
          ScreenPermissions.SHOW_SOLAR_STORAGE_STANDALONE_DATA_ADMIN,
        ],
        matchAny: true,
      }),
    [actionPermits]
  )

  const showSolarStorageData = useMemo(
    _ =>
      hasAccesPermits({
        actionPermits,
        eventActions: [ScreenPermissions.SHOW_SOLAR_STORAGE_DATA],
        matchAny: true,
      }),
    [actionPermits]
  )

  const hasSolarPIRowdata = useMemo(
    _ =>
      hasAccesPermits({
        actionPermits,
        eventActions: [ScreenPermissions.SOLAR_PI_ROW_DATA_READ],
        matchAny: true,
      }),
    [actionPermits]
  )

  const hassolarDataPermission =
    hasSolarPowerData ||
    showSolarStorageData ||
    showSolarStorageStandaloneData ||
    solarReportAccess ||
    hasSolarPIRowdata

  return (
    <React.Fragment>
      {solarAdminScreenAccess && (
        <React.Fragment>
          <Route exact path="/solar/plants" component={SolarPlant} />
          <Route
            exact
            path="/solar/plants-extra-info"
            component={SolarPlantExtraInfo}
          />
          <Route exact path="/solar/entity" component={SolarEntity} />
          <Route
            exact
            path="/solar/days-creation"
            component={SolarDaysCreation}
          />
          <Route
            exact
            path="/solar/inverter-manufacturer"
            component={SolarInverterManufacturer}
          />
          <Route
            exact
            path="/solar/inverter-group"
            component={SolarInverterGroup}
          />
          <Route
            exact
            path="/solar/scada-manufacturer"
            component={SolarScadaManfacturer}
          />
          <Route
            exact
            path="/solar/storage-group"
            component={SolarStorageGroup}
          />
          <Route
            exact
            path="/solar/storage-group-formation"
            component={SolarStorageGroupFormation}
          />
          <Route
            exact
            path="/solar/storage-inverter-manufacturer"
            component={SolarStorageInverterManufacturer}
          />
          <Route
            exact
            path="/solar/storage-manufacturer"
            component={SolarStorageManufacturer}
          />
          <Route exact path="/solar/causecode" component={SolarCausecode} />
          <Route exact path="/solar/errors" component={SolarErrors} />
          <Route exact path="/solar/lockcheck" component={SolarLockcheck} />
          <Route
            exact
            path="/solar/user-acces-right"
            component={SolarUserPlant}
          />
          <Route
            exact
            path="/solar/inverter-group-formation"
            component={SolarInverterFormation}
          />
        </React.Fragment>
      )}
      {solarReportAccess && (
        <Route exact path="/solar/solar-report" component={SolarReport} />
      )}
      {hassolarDataPermission &&
        [
          <Route
            exact
            path="/solar/solar-power-data"
            component={SolarPowerData}
            key="solar-power-data"
          />,
          <Route
            exact
            path="/solar/solar-inverter-perf-data"
            component={SolarInverterPerformacePowerData}
            key="solar-inv-perf-data"
          />,
          showSolarStorageData && (
            <Route
              exact
              path="/solar/solar-storage-data"
              component={SolarStoragePowerData}
              key="solar-storage-data"
            />
          ),
          showSolarStorageStandaloneData && (
            <Route
              exact
              path="/solar/solar-storage-standalone-data"
              component={SolarStorageStandalonePowerData}
              key="solar-storage-data"
            />
          ),
          <Route
            exact
            path="/solar/solar-generation-data"
            component={SolarGenerationData}
            key="solar-generation-data"
          />,
          <Route
            exact
            path="/solar/solar-level2-validation"
            component={SolarLevel2Validation}
            key="solar-level2-validation"
          />,
          solarPiImportIntervals && (
            <Route
              exact
              path="/solar/solar-pi-import-intervals"
              component={SolarPiDataImport}
              key="solar-pi-import-intervals"
            />
          ),
          <Route
            exact
            path="/solar/solar-missing-data"
            component={SolarMissingData}
            key="solar-missing-data"
          />,
          solarFileCreation && (
            <Route
              exact
              path="/solar/solar-file-creation"
              component={SolarFileCreation}
              key="solar-file-creation"
            />
          ),
          solarFileImportCSV && (
            <Route
              exact
              path="/solar/solar-file-inv-import"
              component={SolarCSVImport}
              key="solar-inv-csv-file-import"
            />
          ),
          solarFileImport && (
            <Route
              exact
              path="/solar/solar-nerc-file-import"
              component={SolarNercFileImport}
              key="solar-nerc-file-import"
            />
          ),
          hasSolarPIRowdata && [
            <Route
              exact
              path="/solar/pi-row-10min-data"
              component={SolarPiRow10MinData}
              key="solar/pi-row-10min-data"
            />,
            <Route
              exact
              path="/solar/pi-row-hourly-data"
              component={SolarPiRowHourlyData}
              key="solar/pi-row-hourly-data"
            />,
            <Route
              exact
              path="/solar/pi-row-daily-data"
              component={SolarPiRowDailyData}
              key="solar/pi-row-daily-data"
            />,
          ],
          solarLSBP && [
            <Route
              exact
              path="/solar/solar-lsbp-event"
              component={SolarLSBPEvent}
              key="solar-lsbp-event"
            />,
            <Route
              exact
              path="/solar/solar-lsbp-measurment"
              component={SolarLSBPMeasurment}
              key="solar-lsbp-measurment"
            />,
          ],
        ].filter(f => !!f)}
    </React.Fragment>
  )
}

export { SolarContainer }
